if (!customElements.get('cart-discount-codes')) {
  class CartDiscountCodes extends HTMLElement {
    static SECTIONS_TO_RENDER = ['cart-drawer', 'cart-icon-bubble'];

    constructor() {
      super();

      this.handleRemoveButtonClick = this.handleRemoveButtonClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleRemoveButtonClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleRemoveButtonClick);
    }

    handleRemoveButtonClick(event) {
      const removeButtonElement = event.target.closest('[data-discount-code-remove]');
      if (!removeButtonElement) return;

      this.removeDiscountCode(removeButtonElement);
    }

    getAppliedDiscountCodes() {
      try {
        return JSON.parse(this.dataset.discountCodes);
      } catch {
        return [];
      }
    }

    async removeDiscountCode(removeButtonElement) {
      const removedDiscountCode = removeButtonElement.dataset.discountCodeRemove;
      const remainingDiscountCodes = this.getAppliedDiscountCodes().filter(
        (discountCode) => discountCode !== removedDiscountCode
      );

      this.setLoadingState(true);

      try {
        const response = await fetch(`${routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: remainingDiscountCodes.join(','),
            sections: CartDiscountCodes.SECTIONS_TO_RENDER,
          }),
        });

        if (!response.ok) throw new Error(`Discount removal failed: ${response.status}`);

        const cartState = await response.json();
        document.dispatchEvent(new CustomEvent('cart-drawer:render', { detail: cartState }));
      } catch (error) {
        console.error(error);
        this.setLoadingState(false);
      }
    }

    setLoadingState(isLoading) {
      this.setAttribute('aria-busy', String(isLoading));
      this.querySelectorAll('[data-discount-code-remove]').forEach((removeButtonElement) => {
        removeButtonElement.disabled = isLoading;
      });
    }
  }

  customElements.define('cart-discount-codes', CartDiscountCodes);
}
